import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray, filterArray } from 'helpers/utils';
import { ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function BkbPlayerStats({ data, team }) {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  let teamTotal = findArray(data?.results?.items, { startSortOrder: [team] })?.statsItems;
  let statsArray = ['PTS', 'FG', 'FG', 'P2', 'P3', 'FT', 'REB/', 'ASSIST', 'TO', 'ST', 'BLC', 'PF', 'FD', 'PLUS_MINUS'];
  let items = statsArray.map((item) => {
    let itemStat = item.split('/');
    let val;
    let extendedVal;
    let statsNotPos = Array.isArray(teamTotal) && teamTotal.filter(item => item.pos === undefined)
    val = findArray(teamTotal, { code: [itemStat[0]], pos: ['TOT'] })
    val = val ? val : findArray(statsNotPos, { code: [itemStat[0]] })
    if (itemStat.length > 1) {
      extendedVal = val.extendedStatsItems
    }

    return {
      code: itemStat[0], value: val?.value, attempt: val?.attempt, percent: val?.percent,
      extendedStatsItems: extendedVal
    }
  })

  let extra2 = {
    athlete: { code: '100001' },
    bib: 100001,
    title: <span className='fw-bold'>Totals</span>,
    statsItems:
      items,
  }
  let rebotes = findArray(teamTotal, { code: ['TREB'] })
  let rebotesDR = findArray(rebotes.extendedStatsItems, { code: ['DR'] }).value
  let rebotesOR = findArray(rebotes.extendedStatsItems, { code: ['OR'] }).value
  let rebtesTREB = rebotes.value
  let extra1 = {
    athlete: { code: '100000' },
    bib: 100000,
    title: 'Team / Coach',

    statsItems: [
      {
        code: 'REB', value: rebtesTREB, extendedStatsItems: [
          { code: 'OR', value: rebotesOR },
          { code: 'DR', value: rebotesDR }
        ]
      },
      { code: 'TO', value: findArray(teamTotal, { code: ['TTO'] })?.value },
      { code: 'PF', value: findArray(teamTotal, { code: ['PF_COACH'] })?.value }
    ]
  }

  //Before to inser check if exist yet

  athletes = athletes?.filter(item => item.code !== 100000 && item.code !== 100001)

  athletes.push(extra1)
  athletes.push(extra2)

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorName = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.name;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;
  const stats = [
    { code: 'LEADING' }
  ]

  const tableColumns = useMemo(() =>
    [
      {
        id: 'PlayerStatsBib',
        disableSort: false,
        className: 'text-end',
        headerClassName: 'text-end w-5 text-nowrap',
        Header: <Label data={'HeaderNumber'} />,
        remove: false,
        columnIndex: 1,
        Cell: (props) => {
          let isSuspended = (findArray(props.cell.row.original.eventUnitEntries, { eue_code: ['STATUS'] }).eue_value === 'SUSPEND')
          if (isSuspended) {
            return '(S)'
          }
          return (props.cell.row.original.bib > 99999) ? '' : props.cell.row.original.bib
        }
      },
      ColumnNameH2H({ showStarter: true, showDisciplineClass: true }),
      {
        id: 'PlayerStatsMIN',
        Header: "MIN",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsPTS',
        Header: "PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsFG',
        Header: "FG",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStats2PTS',
        Header: "2PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStats3PTS',
        Header: "3PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P3'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P3'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P3'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsFT',
        Header: "FT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsOR',
        Header: "OR",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          let rebotes = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let rebotesValue = findArray(rebotes.extendedStatsItems, { code: ['OR'] }).value
          return rebotesValue
        }
      },
      {
        id: 'PlayerStatsDR',
        Header: "DR",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 9,
        Cell: (props) => {
          let rebotes = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let rebotesValue = findArray(rebotes.extendedStatsItems, { code: ['DR'] }).value
          return rebotesValue
        }
      },
      {
        id: 'PlayerStatsREB',
        Header: "TOT R",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 10,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['REB'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsASSIST',
        Header: "AS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 11,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['ASSIST'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsTO',
        Header: "TO",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 12,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['TO'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsST',
        Header: "ST",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 13,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['ST'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsBS',
        Header: "BS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 14,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['BLC'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPF',
        Header: "PF",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 15,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PF'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsFD',
        Header: "FD",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 16,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['FD'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPLUS_MINUS',
        Header: "+/-",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 17,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PLUS_MINUS'] }).value}
            </>
          )
        }
      },
    ], []
  )
  const tableColumnsSM = useMemo(() =>
    [
      {
        id: 'PlayerStatsBib',
        disableSort: false,
        className: 'text-end',
        headerClassName: 'text-end w-5 text-nowrap',
        Header: <Label data={'HeaderNumber'} />,
        remove: false,
        columnIndex: 1,
        Cell: (props) => {
          let isSuspended = (findArray(props.cell.row.original.eventUnitEntries, { eue_code: ['STATUS'] }).eue_value === 'SUSPEND')
          if (isSuspended) {
            return '(S)'
          }
          return (props.cell.row.original.bib > 99999) ? '' : props.cell.row.original.bib
        }
      },
      ColumnNameH2H({ showStarter: true, hideNoc: true, showDisciplineClass: true }),
      {
        id: 'PlayerStatsPTS',
        Header: "PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsASSIST',
        Header: "AS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['ASSIST'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsREB',
        Header: "REB",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['REB'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsMIN',
        Header: "MIN",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsFG',
        Header: "FG",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsST',
        Header: "ST",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['ST'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsBS',
        Header: "BS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['BLC'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPF',
        Header: "PF",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 9,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PF'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsFD',
        Header: "FD",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 10,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['FD'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPLUS_MINUS',
        Header: "+/-",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 11,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PLUS_MINUS'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStats2PTS',
        Header: "2PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 12,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStats3PTS',
        Header: "3PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 13,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P3'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P3'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P3'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsFT',
        Header: "FT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 14,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).percent;
          return (
            <><PlayerStatsType2 value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsOR',
        Header: "OR",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 15,
        Cell: (props) => {
          let rebotes = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let rebotesValue = findArray(rebotes.extendedStatsItems, { code: ['OR'] }).value
          return rebotesValue
        }
      },
      {
        id: 'PlayerStatsDR',
        Header: "DR",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 16,
        Cell: (props) => {
          let rebotes = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let rebotesValue = findArray(rebotes.extendedStatsItems, { code: ['DR'] }).value
          return rebotesValue
        }
      },
      {
        id: 'PlayerStatsTO',
        Header: "TO",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 17,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['TO'] }).value}
            </>
          )
        }
      },

    ], []
  )
  let _playersCurrents = filterArray(data?.results?.extendedInfos, { ei_code: ['CURRENT'] });
  let _caption = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />
  const playersCurrents = _playersCurrents && _playersCurrents.map((player) =>
    player.ei_value
  );
  const { breakPoint } = useViewport();

  let columns = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns

  return (
    <>{ }

      <MirsTable
        id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_caption}
        data={athletes}
        columns={columns}
        keyRow={"athlete-code"}
        initialSortBy={[{ id: 'PlayerStatsBib', desc: false }]}
        getRowProps={row => ({
          className: playersCurrents.includes(row?.original?.athlete.code) ? 'currentIndicator' : '',
        })}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '5,5,6' : '9,7'}
        showNavExtendedData={true}
        colIndex={1}
      />
    </>
  );
}

export default BkbPlayerStats;

function CaptionTeam({ competitorNoc, participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div>
  )
}

function PlayerStatsType2({ value, attempt, percent }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}<br />{percent}%
      </>
    )
  }
}